export default {
    RoleManagement: {
        common: {
            RoleName: 'Role Name',
            Status: 'Status',
            create: 'Add Role',
            editsome: 'Edit Role',
            users: 'Assign User',
            menu: 'Assign Menu Permissions',
            Log: 'Log',
            describe: 'Description',
            button: 'Button',
            ps: 'Please enter role name',
        },
        table: {
            RoleName: 'Role Name',
            tenantName: 'Department Name',
            creator: 'Created By',
            Status: 'Status',
            operate: 'Action',
        },
        child: {
            name: 'Role Name',
            add: 'Add User',
            role: 'User Account',
            rolename: 'User Name',
            filter: 'Enter keywords to filter',
        },
        roleNameExists: 'The role name already exists.'
    }
};
